import React from "react";

// Render a native <option> WITHOUT a JSX child so the preview visual-editor
// transform can't wrap the label in a <span> (invalid inside <option> →
// React DOM-nesting/hydration warning). `label` is passed as a raw child.
export const opt = (value, label, props = {}) =>
  React.createElement("option", { value, ...props }, label);
